import { useEffect, useRef } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { pageRoutes } from '../../constants/routes';

/** Multi-step flows that should restart when the user switches workspace. */
function isOrgSensitiveOnboardingPath(pathname: string): boolean {
  if (
    pathname === pageRoutes.onboardingUser ||
    pathname === pageRoutes.onboardingProject ||
    pathname.startsWith(`${pageRoutes.onboardingProject}/`) ||
    pathname === pageRoutes.onboardingEditUser
  ) {
    return true;
  }
  return /^\/onboarding\/projects\/\d+/.test(pathname);
}

function isOnboardingHomePath(pathname: string): boolean {
  return pathname === pageRoutes.onboarding;
}

function OnboardingLayout() {
  const { orgContextVersion, isOrphanOrgUser, isLoading, currentUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const orgContextVersionRef = useRef(orgContextVersion);

  useEffect(() => {
    if (isLoading || !currentUser || !isOrphanOrgUser) return;
    if (!isOnboardingHomePath(location.pathname)) {
      navigate(pageRoutes.onboarding, { replace: true });
    }
  }, [
    isLoading,
    currentUser,
    isOrphanOrgUser,
    location.pathname,
    navigate,
  ]);

  useEffect(() => {
    const previousVersion = orgContextVersionRef.current;
    orgContextVersionRef.current = orgContextVersion;

    if (
      previousVersion !== orgContextVersion &&
      isOrgSensitiveOnboardingPath(location.pathname)
    ) {
      navigate(pageRoutes.onboarding, { replace: true });
    }
  }, [orgContextVersion, location.pathname, navigate]);

  return (
    <div className="flex flex-1 flex-col bg-surface-muted">
      <Outlet />
    </div>
  );
}

export default OnboardingLayout;
